import { render, staticRenderFns } from "./TableProductAddDistributionComponent.vue?vue&type=template&id=372e164a"
import script from "./TableProductAddDistributionComponent.vue?vue&type=script&lang=js"
export * from "./TableProductAddDistributionComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports